import { DialpadIcon } from './DialpadIcon';

/**
 * author: Google
 * id B732FAD7-93A7-478E-810F-835069DE6EDB
 * name dialpad
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dialpad.svg
 * tags
 */
export const KeypadIcon = DialpadIcon;
export default KeypadIcon